(function () {
    'use strict';

    angular
        .module('app')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['$http', '$rootScope', '$state', '$cookies', '$scope', '$filter', 'authenticator', '$stateParams', 'emojiReplacer', 'cache', 'countries'];

    function SettingsController($http, $rootScope, $state, $cookies, $scope, $filter, authenticator, $stateParams, emojiReplacer, cache, countries) {
        $rootScope.header_inverted = false;
        $rootScope.on_dashboard = false;
        $rootScope.separate_page = false;
        $rootScope.dark_text_header = true;
        var phone;
        var vm = this;
        vm.editMode = false;
        vm.updateUser = updateUser;
        vm.countryISOToName = countryISOToName;
        vm.logout = logout;
        vm.countries = countries;
        vm.connectWithFacebook = connectWithFacebook;
        vm.removeFacebookConnection = removeFacebookConnection;
        vm.resetPassword = resetPassword;

        vm.$onInit = function () {
            window.document.title = $stateParams.language == 'da' ? "Din profil - Be My Concert" : "Your profile - Be My Concert";
            Promise.all([getUser(),]).then(function () {
                getUserAffiliates();
                stripeGetVerificationStatus();
                userHasPublicConcert();
                setTimeout(function () {
                    var input = document.querySelector("#phone");
                    phone = window.intlTelInput(input, {
                        utilsScript: "app/assets/js/utils.js",
                        preferredCountries: ["dk", "gb"],
                        formatOnDisplay: false,
                        defaultCountry: vm.user.user_phone_country_code ? vm.user.user_phone_country_code.toLowerCase() : 'dk',
                        customContainer: "international-phone-input"
                    });
                }, 0);
            });

        };

        function countryISOToName(ISO) {
            return vm.countries && ISO ? (vm.countries.find(country => country.code == ISO)).name : "";
        }

        function userHasPublicConcert() {
            return $http.get('/app/api/private/users/has_public_concert').then(function (response) {
                vm.has_public_concert = response.data;
            });
        }

        $scope.$on('$destroy', function () {
            $rootScope.dark_text_header = false;
            $rootScope.separate_page = false;
        })

        function getUser() {
            if (cache.exists('user')) {
                vm.user = cache.load('user');
                return Promise.resolve();
            } else {
            return $http.get('api/private/users/')
                .then(function (response) {
                    vm.user = response.data;
                    cache.save('user', vm.user);
                });
            }
        }

        function stripeGetVerificationStatus() {
            return $http.post('/app/api/users/me/stripe_get_verification_status', {}).then(function (response) {
                vm.stripeStatusLoaded = true;
                vm.stripeVerified = response.data.status == "verified" && response.data.document.front != null;
                vm.stripeVerificationPending = response.data.status == "pending";
                vm.showVerificationError = response.data.status == "unverified" && response.data.document.front != null && response.data.additional_document.front != null && response.data.details_code != null;
                vm.stripeVerificationDetails = response.data.details;
                vm.stripeVerificationDetailsCode = response.data.details_code;
                vm.showStripeStatus = response.data.status != undefined && response.data.status != "unverified";
            });
        }

        function getUserAffiliates() {
            return $http.get('api/users/user_affiliates/')
                .then(function (response) {
                    vm.user_has_band = response.data.affiliates.band != null;
                    vm.user_has_space = response.data.affiliates.space != null;
                });
        }

        function updateUser() { //Updates data about user based on inputted data
            if(!vm.settingsForm.$valid){
                return;
            }
            var data = {};
            if (vm.editMode == 'your_information') {
                vm.user.user_phone = phone.getNumber();
                data.user_phone = vm.user.user_phone;
                data.user_firstname = vm.user.user_firstname;
                data.user_lastname = vm.user.user_lastname;
                data.user_postcode = vm.user.user_postcode;
                data.user_country = vm.user.user_country;
                data.user_firstname = vm.user.user_firstname;
            }

            if (vm.editMode == 'login') {
                data.user_email = vm.user.user_email;
            }

            $http.patch('api/users/' + vm.user.user_slug + '/', data)
                .then(function (response) {
                    if (vm.editMode == 'login') {
                        if (!response.data.email_in_use && !response.data.same_email_as_before) {
                            vm.email_in_use = false;
                            $cookies.put('_user_email_', vm.user.user_email, { path: '/' });
                        }
                        if (response.data.email_in_use && !response.data.same_email_as_before){
                            vm.email_in_use = true;
                        }
                        if (response.data.email_in_use && response.data.same_email_as_before){
                            vm.email_in_use = false;
                        }
                    }

                    cache.save('user', vm.user);
                    vm.editMode = false;
                });
        }

        function logout() {
            authenticator.logout()
                .then(function (response) {
                    $rootScope.$broadcast('check_login_status');
                    $state.go('frontpage');
                });
        }

        function connectWithFacebook() {
            vm.connect_disabled = true;
            return authenticator.promptFacebookLogin().then(function (facebookResponse) {
                if (facebookResponse && facebookResponse.status === 'connected') {
                    return $http.post('api/users/connect/facebook/', {})
                        .then(function (response) {
                            vm.connect_disabled = false;

                            if (response.data.user_firstname) {
                                vm.user.connected_with_facebook = true;
                                vm.user.user_firstname = response.data.user_firstname;
                                vm.user.user_lastname = response.data.user_lastname;
                                vm.user.user_email = response.data.user_email;
                                vm.user.user_location = response.data.user_location;
                                vm.user.user_phone = response.data.user_phone;
                            }
                        });
                } else {
                    vm.connect_disabled = false;
                    console.error("Not logged into Facebook");
                }
            });
        }

        function removeFacebookConnection() {
            if (confirm("This will remove every connection between your user and Facebook. You will not be able to login with Facebook in the future without reconnecting. Please make sure that you know your password.\n\nThis action might log you out of Be My Concert. \n\nDo you still want to remove the connection with Facebook?")) {
                vm.connect_disabled = true;
                return $http.post('api/users/disconnect/facebook/', {})
                    .then(function (response) {
                        vm.user.connected_with_facebook = false;
                    });
            }
        }

        function resetPassword()
        {
            return $http.post('/app/api/users/forgotten_password', {email: vm.user.user_email})
                .then(function(response){
                    $state.go('forgotten_password', {"user_email": vm.user.user_email});
                });
        }

    }
})();
